// eslint-disable-next-line
import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class Autorizacao extends CoreBase implements IAutorizacao {
  async autorizacaoAlteraCotacaoExtraGrupo(solicitacaoId: string, data: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.autorizacaoAlteraCotacaoExtraGrupo(solicitacaoId, data)
    return response
  }

  async enviarGuias(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.autorizaSolicitacao(params.body.solicitacaoId, params.acao, params.body)
    return response
  }

  async renovarAutorizacaoOperadora(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.renovarAutorizacaoOperadora(solicitacaoId)
    return response
  }

  async suprimentosFazCotacao(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.suprimentosFazCotacao(params.body.solicitacaoId, params.acao, params.body)
    return response
  }

  async getContestacaoMedica(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.ContestacaoMedicaApi.get(solicitacaoId)
    return response
  }

  async aceitarContestacao(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.ContestacaoMedicaApi.aceitarContestacao(solicitacaoId)
    return response
  }

  async recusarContestacao(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.ContestacaoMedicaApi.recusarContestacao(solicitacaoId)
    return response
  }

  async abrirContestacao(solicitacaoId: string, data: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.ContestacaoMedicaApi.abrirContestacao(solicitacaoId, data)
    return response
  }

  async enviarMensagem(solicitacaoId: string, data: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.ContestacaoMedicaApi.enviarMensagem(solicitacaoId, data)
    return response
  }

  async uploadDocumentoContestacao(hospitalId: string, formData: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.ContestacaoMedicaApi.uploadDocumento(hospitalId, formData)
    return response
  }

  async gerarGuias(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getSolicitacaoGuias(params)
    return response
  }
}

interface IAutorizacao extends ICoreBase {
  autorizacaoAlteraCotacaoExtraGrupo(solicitacaoId: string, data: any): Promise<ResponseApi>
  enviarGuias(params: any): Promise<ResponseApi>
  renovarAutorizacaoOperadora(solicitacaoId: string): Promise<ResponseApi>
  suprimentosFazCotacao(params: any): Promise<ResponseApi>
  getContestacaoMedica(solicitacaoId: string): Promise<ResponseApi>
  aceitarContestacao(solicitacaoId: string): Promise<ResponseApi>
  recusarContestacao(solicitacaoId: string): Promise<ResponseApi>
  abrirContestacao(solicitacaoId: string, data: any): Promise<ResponseApi>
  enviarMensagem(solicitacaoId: string, data: any): Promise<ResponseApi>
  uploadDocumentoContestacao(hospitalId: string, formData: any): Promise<ResponseApi>
  gerarGuias(params: any): Promise<ResponseApi>
}

export {
  Autorizacao,
  IAutorizacao,
}
